export const frWorkerOnboardingPolicy = {
  "Worker onboarding policy": "Politique d’inscription des travailleurs",
  "Choose required profile information and documents. Collection does not verify identity or grant permission to work. Document approval uses existing reviewer permissions.": "Choisissez les renseignements et documents requis. Leur collecte ne vérifie pas l’identité et n’autorise pas le travail. L’approbation utilise les permissions de révision existantes.",
  "Loading onboarding policy": "Chargement de la politique d’inscription",
  "Required profile information": "Renseignements de profil requis",
  "Required onboarding documents": "Documents requis pour l’inscription",
  "Save onboarding policy": "Enregistrer la politique d’inscription",
  "Reload onboarding policy": "Recharger la politique d’inscription",
  "Unable to load onboarding policy.": "Impossible de charger la politique d’inscription.",
  "Unable to save onboarding policy. Reload before trying again.": "Impossible d’enregistrer la politique. Rechargez-la avant de réessayer.",
  "Onboarding policy saved.": "Politique d’inscription enregistrée.",
  "Name": "Nom",
  "Phone": "Téléphone",
  "Skills": "Compétences",
  "Availability": "Disponibilités",
  "Emergency contact": "Contact d’urgence",
  "Languages": "Langues",
  "Work area": "Zone de travail",
  "Documents": "Documents",
  "Profile photo": "Photo de profil",
  "Resume": "CV",
  "Certificate": "Certificat",
  "License": "Permis",
  "Training card": "Carte de formation",
  "Safety induction": "Formation d’accueil en sécurité",
  "Safety card": "Carte de sécurité",
  "Government ID": "Pièce d’identité officielle",
  "Iqama": "Iqama",
  "Passport": "Passeport",
  "National ID": "Carte d’identité nationale",
  "Driver license ID": "Permis de conduire",
  "Work permit": "Permis de travail",
  "Site access card": "Carte d’accès au site",
  "Medical clearance": "Attestation médicale",
  "Immigration document": "Document d’immigration",
  "Portfolio": "Portfolio",
  "Trade certificate": "Certificat de métier"
}
export const arWorkerOnboardingPolicy = {
  "Worker onboarding policy": "سياسة تسجيل العاملين",
  "Choose required profile information and documents. Collection does not verify identity or grant permission to work. Document approval uses existing reviewer permissions.": "اختر معلومات الملف والمستندات المطلوبة. جمعها لا يتحقق من الهوية ولا يمنح إذن العمل. تعتمد الموافقة على صلاحيات المراجعين الحالية.",
  "Loading onboarding policy": "جارٍ تحميل سياسة التسجيل",
  "Required profile information": "معلومات الملف المطلوبة",
  "Required onboarding documents": "مستندات التسجيل المطلوبة",
  "Save onboarding policy": "حفظ سياسة التسجيل",
  "Reload onboarding policy": "إعادة تحميل سياسة التسجيل",
  "Unable to load onboarding policy.": "تعذر تحميل سياسة التسجيل.",
  "Unable to save onboarding policy. Reload before trying again.": "تعذر حفظ السياسة. أعد تحميلها قبل المحاولة مجدداً.",
  "Onboarding policy saved.": "تم حفظ سياسة التسجيل.",
  "Name": "الاسم",
  "Phone": "الهاتف",
  "Skills": "المهارات",
  "Availability": "التوفر",
  "Emergency contact": "جهة اتصال الطوارئ",
  "Languages": "اللغات",
  "Work area": "منطقة العمل",
  "Documents": "المستندات",
  "Profile photo": "صورة الملف",
  "Resume": "السيرة الذاتية",
  "Certificate": "شهادة",
  "License": "رخصة",
  "Training card": "بطاقة تدريب",
  "Safety induction": "تدريب السلامة التمهيدي",
  "Safety card": "بطاقة سلامة",
  "Government ID": "هوية حكومية",
  "Iqama": "إقامة",
  "Passport": "جواز سفر",
  "National ID": "هوية وطنية",
  "Driver license ID": "رخصة قيادة",
  "Work permit": "تصريح عمل",
  "Site access card": "بطاقة دخول الموقع",
  "Medical clearance": "تصريح طبي",
  "Immigration document": "مستند هجرة",
  "Portfolio": "ملف أعمال",
  "Trade certificate": "شهادة مهنية"
}
